import React from 'react';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { InputOption } from 'components/common/MyCustomSelect/components/InputOption/InputOption';
import { ValueContainer } from 'components/common/MyCustomSelect/components/ValueContainer/ValueContainer';

import { Radio } from 'components/DesignSystem/Radio';
import { Select } from 'components/DesignSystem/Select';
import classes from 'components/widgets/Trends/components/Filters/Filters.module.scss';
import { SingleLineOptions } from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph';

export const Filters = ({ sourceData, handleSingle, options, handleSelectOptions }) => {
    const isMultiple = sourceData.singleLine === 'Multi Parameters (Normalized values)';
    const isNote = sourceData.selectedOptions?.note;

    const controlProps = (item: SingleLineOptions) => ({
        checked: sourceData.singleLine === item,
        onChange: handleSingle,
        value: item,
        name: 'show-option',
    });
    return (
        <div className={classes.selectParametersWrapper}>
            <div className={classes.radiosRow}>
                <span>Show: </span>
                <div className={classes.radioContainer}>
                    <Radio
                        {...controlProps('Pre-defined Combinations (Normalized values)')}
                        label={'Pre-defined Combinations (Normalized values)'}
                    />

                    <Radio
                        {...controlProps('Multi Parameters (Normalized values)')}
                        label={'Multi Parameters (Normalized values)'}
                    />

                    <Radio
                        {...controlProps('Single Parameter (Actual value)')}
                        label={'Single Parameter (Actual value)'}
                    />
                </div>
            </div>
            <div data-testid={'select-row'} className={classes.selectRow}>
                <Select<ISelectOption<string>, typeof isMultiple>
                    value={sourceData.selectedOptions}
                    options={options}
                    onChange={handleSelectOptions}
                    closeMenuOnSelect={!isMultiple}
                    hideSelectedOptions={!isMultiple}
                    isMulti={isMultiple}
                    placeholder={'Select Items...'}
                    components={
                        isMultiple
                            ? {
                                  Option: InputOption,
                                  ValueContainer: ValueContainer,
                              }
                            : {}
                    }
                />
            </div>
            {isNote && (
                <div className={classes.lookForContainer}>
                    <MuiIcon icon={'report'} color={'#4c9bfa'} className={classes.reportIcon} />
                    {isNote}
                </div>
            )}
        </div>
    );
};
